// Movies redux action types
export const RESET_MOVIES = 'RESET_MOVIES';
export const SET_MOVIES_PAGE = 'SET_MOVIES_PAGE';
export const OPEN_MOVIE_MODAL = 'OPEN_MOVIE_MODAL';
export const CLOSE_MOVIE_MODAL = 'CLOSE_MOVIE_MODAL';
export const ADD_MOVIE = 'ADD_MOVIE';
export const EDIT_MOVIE_INFO = 'EDIT_MOVIE_INFO';
export const DELETE_MOVIE = 'DELETE_MOVIE';
